import React from 'react';
import { Button, Form, Input, Segment, Tab } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const object = {};
const fetchGradingMethods = () => axios.get('/grading-methods');
const fetchExamTypes = () => axios.get('/graded-activity-types');
const fetchStaff = (courseId) => axios.get(`/course/implementation/staff/${courseId}`);
const fetchExamTerms = (academicYearId) => axios.get(`/exams/gard-by-academic-year/${academicYearId}/`);


export default class NewExam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            name: '',
            academicYearId: '',
            gradingMethods: [],
            examTypes: [],
            examTerms: [],
            courseStaff: [],
            groups: [],
            groupIds: null,

            gradingMethod: '',
            examType: '',
            examTerm: '',
            staffArray: [],
            date: null,
            classroom: '',
            comment: '',

            gradingMethodErr: false,
            examTypeErr: false,
            examTermErr: false,
            staffArrayErr: false,
            dateErr: false,
            added: null,

            startDate: null,
            endDate: null,
            disabledButton: false,
            loadingButton: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addExam = this.addExam.bind(this);
        this.fetchAll = this.fetchAll.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }

    componentDidMount() {
        if (this.props !== undefined) {
            this.setState({ id: this.props.id, name: this.props.name, academicYearId: this.props.academicYearId });
            this.fetchAll(this.props.id, this.props.academicYearId);
        } else this.fetchAll(this.state.id, this.state.academicYearId);

        axios.get('/group-types')
            .then(res => {
                const groupType = res.data.find(e => e._key === 'exam').id;
                let obj = {};
                axios.post(`course/groups/${this.props.id}/${groupType}`, { ...obj })
                    .then(res => {
                        let groups = res.data.filter(e => !e.archived).map(el => ({
                            text: el.name, value: el.id, key: el.id
                        }));
                        this.setState({
                            groups,
                            haveGroup: groups.length !== 0
                        });
                    })
                    .catch(err => {
                        console.log('Failed to fetch groups');
                    });
            })
            .catch(err => {
                console.log('Failed to fetch group types');
            });
    }


    fetchAll(id, academicYearId) {
        axios.all([fetchGradingMethods(), fetchExamTypes(), fetchStaff(id), fetchExamTerms(academicYearId)])
            .then(axios.spread((gradingMethodRes, examTypeRes, staffRes, termsRes, groupsRes) => {
                const gradingMethods = gradingMethodRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el._key
                }));
                const examTypes = examTypeRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));
                const courseStaff = staffRes.data.map(el => ({
                    ...el, text: el.employee.person.firstName + ' ' + el.employee.person.lastName + ' - ' + el.courseRoleType.name, value: el.id, key: el.id
                }));
                const examTerms = termsRes.data.map(el => ({
                    ...el,
                    text: el.name + ' (' + moment(el.startDate).format('D. M. YYYY.') + ' - ' + moment(el.endDate).format('D. M. YYYY.') + ')',
                    value: el.id + 1,
                    key: el.id + 1
                }));

                this.setState({
                    gradingMethods,
                    gradingMethodId: gradingMethods.find(e => e.key === 'written exam').id,
                    examTypes,
                    courseStaff,
                    examTerms: localStorage.getItem('thirdCycle') === 'true' || localStorage.getItem('specialist') === 'true' ? examTerms : examTerms.filter(el => el.endDate >= moment()),
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch data...');
            });
    }


    addExam(examTerm, examTypeId, gradingMethodId, date, staffArray, classroom, groupIds, comment) {
        if (!examTerm || !examTypeId || !gradingMethodId || !date || (staffArray.length === 0 && (localStorage.getItem('thirdCycle') === 'false' && localStorage.getItem('specialist') === 'false'))) {
            toast('Niste unijeli sva obavezna polja!');
            if (!examTerm) { this.setState({ examTermErr: true }); } else { this.setState({ examTermErr: false }); }
            if (!examTypeId) { this.setState({ examTypeErr: true }); } else { this.setState({ examTypeErr: false }); }
            if (!gradingMethodId) { this.setState({ gradingMethodIdErr: true }); } else { this.setState({ gradingMethodIdErr: false }); }
            if (!date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (staffArray.length === 0 && localStorage.getItem('thirdCycle') === 'false') { this.setState({ staffArrayErr: true }); } else { this.setState({ staffArrayErr: false }); }
            this.setState({ disabledButton: false, loadingButton:false });
        } else if ((localStorage.getItem('thirdCycle') === 'false' && localStorage.getItem('specialist') === 'false') && !groupIds && staffArray.filter(el => this.state.courseStaff.find((e) => e.id === el).leadStaff).length !== 1) {
            this.setState({
                staffArrayErr: true,
                disabledButton: false,
                loadingButton:false
            });
            toast('Ispit mora imati tačno jednog profesora nosioca!');
        } else if ((localStorage.getItem('thirdCycle') === 'false' && localStorage.getItem('specialist') === 'false') && groupIds && staffArray.filter(el => this.state.courseStaff.find((e) => e.id === el).courseRoleType.name === 'profesor').length !== 1) {
            this.setState({
                staffArrayErr: true,
                disabledButton: false,
                loadingButton:false
            });
            toast('Ispit sa grupom mora imati tačno jednog profesora!');
        } else {
            const {
                examTypes, gradingMethods
            } = this.state;
            this.setState({
                staffArrayErr: false,
                examTermErr: false,
                examTypeErr: false,
                dateErr: false,
                gradingMethodErr: false,
                disabledButton: false,
                loadingButton:false
            });
            const courseImplementationId = this.props.id;
            let examDate = moment(date).format();

            const gradedActivityRegistrationDate = { id: examTerm - 1 };

            const staff = staffArray.map(el => ({ id: el }));

            let gradedActivityTypeKey = examTypes.find(el => el.id === examTypeId)._key;

            let gradingMethodKey = gradingMethods.find(el => el.id === gradingMethodId)._key;


            let docExam = {
                gradedActivityRegistrationDate,
                courseImplementationId,
                gradedActivityTypeKey,
                gradingMethodKey,
                examDate,
                staff,
                classroom
            };

            if (comment) { docExam = { ...docExam, comment }; }

            this.setState({loadingButton:true})
            axios.post('exams/false', { ...docExam })
                .then(res => {
                    if (groupIds) {
                        let groups = [];
                        groups.push(groupIds);
                        axios.post(`exams/add-group/${res.data.gradedActivityId}`, [...groups])
                            .then(() => {
                                toast('Uspješno ste kreirali ispit i dodali grupu na ispit.');
                                this.resetForm();
                                this.setState({loadingButton:false})
                            }).catch(err => {
                                toast('Došlo je do greške. Dodavanje grupe na ispit nije uspjelo.');
                            });
                    } else {
                        toast('Uspješno ste kreirali ispit.');
                        this.resetForm();
                        this.setState({loadingButton:false})

                    }
                })
                .catch(err => {
                    toast('Došlo je do greške. Kreiranje ispita nije izvršeno.');
                    this.setState({loadingButton:false})

                });
        }
    }


    handleChange(name, date) {
        if (moment(date).format('D.M.YYYY.') !== moment(this.state.startDate).format('D.M.YYYY.') && moment(date).format('D.M.YYYY.') !== moment(this.state.endDate).format('D.M.YYYY.')) {
            if (date < this.state.startDate || date > this.state.endDate) {
                toast('Datum ispita mora biti unutar vremenskog intervala odabranog ispitnog roka!');
                return;
            }
        }

        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        if (name === 'examTerm') {
            this.setState({
                endDate: this.state.examTerms.find(el => el.id === value - 1).endDate,
                startDate: this.state.examTerms.find(el => el.id === value - 1).startDate
            });
        }
    }
    resetForm() {
        this.setState({
            examTerm: null,
            date: null,
            examType: null,
            gradingMethodId: null,
            groupIds: null,
            staffArray: [],
            classroom: '',
            comment: '',
            disabledButton: false,
            loadingButton:false
        });
    }

    render() {
        return (
            <div>
                <Form noValidate>
                    <Form.Group widths="equal" >
                        <Form.Field required error={this.state.examTermErr}>
                            <label>Ispitni rok</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite ispitni rok"
                                value={this.state.examTerm}
                                onChange={this.handleInputChange}
                                name="examTerm"
                                options={this.state.examTerms}
                                search
                                fluid
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.dateErr} disabled={!this.state.examTerm}>
                            <label>Datum i vrijeme ispita</label>
                            <DateTimePicker
                                defaultValue={new Date()}
                                format="D. M. YYYY. - HH:mm"
                                timeFormat="HH:mm"
                                onChange={this.handleChange.bind(null, 'date')}
                                value={this.state.date}
                                placeholder="Unesite datum u formatu D. M. GGGG."
                            />
                        </Form.Field>

                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.examTypeErr}>
                            <label>Tip ispita</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite tip ispita"
                                value={this.state.examType}
                                onChange={this.handleInputChange}
                                name="examType"
                                options={this.state.examTypes.filter(el => el.id === 2 || el.id === 3)}
                                search
                                fluid
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.gradingMethodIdErr}>
                            <label>Način ispitivanja</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite način ispitivanja"
                                value={this.state.gradingMethodId}
                                onChange={this.handleInputChange}
                                name="gradingMethodId"
                                options={this.state.gradingMethods}
                                search
                                fluid
                            />
                        </Form.Field>
                    </Form.Group>

                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Ispitna grupa</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite grupu"
                                value={this.state.groupIds}
                                onChange={this.handleInputChange}
                                name="groupIds"
                                options={this.state.groups}
                                search
                                fluid
                            />

                        </Form.Field>

                        <Form.Field required={localStorage.getItem('thirdCycle') === 'false' && localStorage.getItem('specialist') === 'false'} error={this.state.staffArrayErr}>
                            <label>Osoblje zaduženo za ispit</label>
                            <Form.Dropdown
                                clearable
                                selection
                                multiple
                                placeholder="Odaberite osoblje"
                                value={this.state.staffArray}
                                onChange={this.handleInputChange}
                                name="staffArray"
                                options={!this.state.haveGroup ? this.state.courseStaff.filter(el => (el.archived !== true && (el.leadStaff === true || el.courseRoleType.name === 'asistent'))) : this.state.courseStaff.filter(el => el.archived !== true)}
                                search
                                fluid
                            />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            label="Prostorija"
                            control={Input}
                            name="classroom"
                            value={this.state.classroom}
                            onChange={this.handleInputChange}
                            placeholder="Unesite prostoriju"
                        />
                        <Form.Field>
                            <label> Napomena</label>
                            <Form.TextArea
                                placeholder="Unesite napomenu"
                                rows={2}
                                name="comment"
                                value={this.state.comment}
                                onChange={this.handleInputChange}
                            />
                        </Form.Field>
                    </Form.Group>


                    <Button
                        disabled={this.state.loadingButton}
                        floated="right"
                        basic="true"
                        color="blue"
                        onClick={() => {
                            this.resetForm();
                            this.setState({ added: null });
                        }}
                    >
                        Odustani
                    </Button>

                    <Button
                        floated="right"
                        color="blue"
                        disabled={this.state.disabledButton || this.state.loadingButton}
                        loading={this.state.loadingButton}
                        onClick={
                            () => {
                                this.setState({ disabledButton: true,loadingButton: true }, () => {
                                    this.addExam(
                                        this.state.examTerm,
                                        this.state.examType,
                                        this.state.gradingMethodId,
                                        this.state.date,
                                        this.state.staffArray,
                                        this.state.classroom,
                                        this.state.groupIds,
                                        this.state.comment
                                    );
                                });
                            }
                        }
                    >
                        Kreiraj ispit
                    </Button>

                </Form>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/NewExam.js